import { render, staticRenderFns } from "./EbirdHeaderFooterTweaks.vue?vue&type=template&id=3d75d2b8&"
import script from "./EbirdHeaderFooterTweaks.vue?vue&type=script&lang=js&"
export * from "./EbirdHeaderFooterTweaks.vue?vue&type=script&lang=js&"
import style0 from "./EbirdHeaderFooterTweaks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports